export default __webpack_public_path__ + "static/media/ic_mai_24.1b75a960.svg";